import { useQueryClient } from '@tanstack/react-query'
import { useCallback } from 'react'

import { shipmentOrdersQueryKeys } from '../query-keys'

/**
 * 検索結果サマリーを無効化する（#5285 2.1）。
 *
 * サマリーは staleTime 5 分で保持する（ページ送りで集計を走らせないため）。
 * そのぶん、依頼の件数や内容を変える操作では明示的に無効化しないと、
 * 一覧だけが新しくなってサマリーが古い値を出し続ける。
 * 件数を変えない編集（数量・重量の変更）も対象になるので、
 * 件数の比較ではなく「依頼を書き換えたら無効化する」で揃える。
 *
 * tenantKey 配下のサマリーを条件ごと（summaryAll）まとめて無効化する。
 * 呼び出し側が今どの検索条件を見ているかを知らなくても効かせるため
 */
export const useInvalidateShipmentOrdersSummary = (tenantKey: string) => {
  const queryClient = useQueryClient()
  return useCallback(
    () =>
      queryClient.invalidateQueries({
        queryKey: shipmentOrdersQueryKeys.summaryAll(tenantKey)
      }),
    [queryClient, tenantKey]
  )
}
